import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useSaveDocument from "../../hooks/useSaveDocument";

import CircularProgress from "@mui/material/CircularProgress";
import { clearData } from "../../features/datatable/dataTableSlice";
import { useDispatch } from "react-redux";
import { patchNewSheet } from "../../utils/variables";
import { useRef } from "react";
// When users go to this page, a new document will be created
// and they will be redirected to it.
const NewFile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { newDocument } = useSaveDocument();

  const docCreatedRef = useRef(false);

  useEffect(() => {
    dispatch(clearData());
  }, [dispatch]);

  const redirect = async () => {
    try {
      const { id } = await newDocument();
      await patchNewSheet([{ page: 1, id }]);
      navigate(`/file/${id}`);
    } catch (error) {
      console.log(error.message);
    }
  };
  useEffect(() => {
    if (docCreatedRef.current) return;
    docCreatedRef.current = true;

    redirect();
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <CircularProgress />
    </div>
  );
};

export default NewFile;
